// refactored (GeoJSON prefix added) form of package @types/geojson
export const isGeoJSONFeature = (feature) => {
    return Object.hasOwn(feature, 'type') && feature.type === 'Feature';
};
//# sourceMappingURL=GeoJSONFeature.js.map